module.exports = __webpack_public_path__ + "static/media/listing-page-karjat.2f3406f5.webp";